module.exports = __webpack_public_path__ + "img/Colorization7.ef4cf641.webp";